import { updateHistoryStackAfterErase } from '../../utils/undoRedoUtils.js'

export const handleBlockEraserUp = (state) => {
  const {
    paths,
    erasedPathKeys,
    setIsBlockEraserActive,
    boardId,
    ydocRef,
    yPathsRef,
    historyStack,
    setHistoryStack,
  } = state

  setIsBlockEraserActive(false)

  // 종료조건) 아무것도 지워지지 않았으면 종료
  if (!erasedPathKeys.current.length) return
  // 종료조건) 실제로 존재하는 pathKey만 필터링 -> 아무것도 유효하지 않으면 종료
  const validErasedKeys = erasedPathKeys.current.filter((key) => key in paths)
  if (!validErasedKeys.length) {
    erasedPathKeys.current = []
    return
  }

  let eraseStack = {
    type: 'erase',
    pathKeys: validErasedKeys,
    pathData: Object.fromEntries(validErasedKeys.map((k) => [k, paths[k]])),
  }

  /**
   * 지우기 선택된 path 삭제, 지우기 완료 후 zIndex 재정렬
   */
  const remainingPaths = Object.entries(paths).filter(([key]) => !validErasedKeys.includes(key))

  ydocRef.current.transact(() => {
    validErasedKeys.forEach((key) => yPathsRef.current.delete(key))
    let newZIndex = 0
    remainingPaths.forEach(([key, path]) => {
      const yPath = yPathsRef.current.get(key)
      if (yPath) {
        yPath.set('zIndex', newZIndex)
        newZIndex++
      }
    })
  })

  /**
   * 상태 정리
   */
  erasedPathKeys.current = []
  // [undo/redo] 히스토리 스택에 기록
  updateHistoryStackAfterErase({ boardId, eraseStack, historyStack, setHistoryStack })
}
